import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Paper } from '@material-ui/core'
import i18n from '../../i18n'

const ImprintDE = () => {
  return (
    <div className="impressum">
      <h3>Keller & Kalmbach GmbH </h3>
      <p>
      Siemensstraße 19 <br />
      85716 Unterschleißheim
      </p>

      <p>info@sfs.ch</p>

      <p>
        T +49 089/8395-0 
      </p>

      <p>
      Geschäftsführer: Hans van der Velden, Gerhard Hemmer, Rudolf Karl, Thomas Obermeyer<br />
      Vorsitzender des Aufsichtsrates: Dr. Florian Seidl
        <br />
        Registergericht München HRB 54200<br/>
        Ust.-Id.-Nr. DE 811180359
        <br />
        
      </p>
    </div>
  )
}

const ImprintEN = () => {
  return (
    <div className="impressum">
      <h3>Keller & Kalmbach GmbH </h3>
      <p>
      Siemensstraße 19 <br />
      85716 Unterschleißheim
      </p>

      <p>info@sfs.ch</p>

      <p>
        T +49 089/8395-0 
      </p>

      <p>
      Geschäftsführer: Hans van der Velden, Gerhard Hemmer, Rudolf Karl, Thomas Obermeyer<br />
      Vorsitzender des Aufsichtsrates: Dr. Florian Seidl
        <br />
        Registergericht München HRB 54200<br/>
        Ust.-Id.-Nr. DE 811180359
        <br />
        
      </p>
    </div>  
  )
}

const ImprintDialog = ({ open, onClose }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div>
      <Dialog open={open} fullWidth maxWidth={'sm'} aria-labelledby="imprint-dialog-title">
        <div className={classes.dialogTitleContainer}>
          <DialogTitle id="imprint-dialog-title">
            <div>{t('imprint')}</div>
          </DialogTitle>
        </div>
        <Divider />
        <DialogContent className={classes.dialogContent}>
          <Paper className={classes.listPaper}>
            <DialogContentText>{i18n.language === 'de' ? <ImprintDE /> : <ImprintEN />}</DialogContentText>
          </Paper>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button type="submit" color="primary" onClick={onClose}>
            {t('close')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  dialogTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: theme.spacing(3),
  },
  dialogContent: {
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    height: 440,
  },
  listPaper: {
    flex: 1,
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    boxShadow: 'none',
    overflow: 'auto',
    overflowY: 'auto',
    overflowX: 'hidden',
    color: 'inherit',
    backgroundColor: 'transparent',
  },
}))

export default ImprintDialog
